function CefrSubBar(props) {

  // Define functions
  const title = props.title;
  const scoreObject = props.scoreObject;
  // const label = scoreObject.label;
  const score = scoreObject.score;
  const width = `${score}%`;


  return (
    <div class='cefr-sub-bar-wrapper'>
      <h4>{title}</h4>

      <div class='flex-row cefr-sub-bar-container'>

        <div class='cefr-sub-bar-outer'>
          <div class='cefr-sub-bar-inner' style={{width: width}}></div>
        </div>
        {/* <p>{label}</p> */}
        <p>{score}<small style={{color: '#8F8F8F'}}>/100</small></p>
      </div>
    </div>
  );
}

export default CefrSubBar;